import { render, staticRenderFns } from "./DownloadFullData.vue?vue&type=template&id=1bc5978c&scoped=true"
import script from "./DownloadFullData.vue?vue&type=script&lang=ts"
export * from "./DownloadFullData.vue?vue&type=script&lang=ts"
import style0 from "./DownloadFullData.vue?vue&type=style&index=0&id=1bc5978c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5978c",
  null
  
)

export default component.exports